const React = require('react');
const { Helmet } = require('react-helmet');

const defaultPluginOptions = {
  noTrailingSlash: false,
  noQueryString: false,
  noHash: false,
};

export const wrapPageElement = ({ element, props: { location } }, pluginOptions = {}) => {
  const options = Object.assign({}, defaultPluginOptions, pluginOptions);

  const siteUrl = `https://www.foundryfivetype.com`;

  let pathname = location.pathname || '/';

  if (options.noTrailingSlash && pathname.endsWith('/'))
    pathname = pathname.substring(0, pathname.length - 1);

  let myUrl = `${siteUrl}${pathname}`;

  return (
    <>
      <Helmet
        link={[
          {
            rel: 'canonical',
            key: myUrl,
            href: myUrl,
          },
        ]}
        meta={[
          {
            name: 'og:url',
            content: myUrl,
          },
          {
            name: 'twiter:url',
            content: myUrl,
          },
        ]}
      />
      {element}
    </>
  );
};
